export default {
  // 搜索区
  sn: '中奖单号',
  snPlaceholder: '请输入中奖单号',
  code_sn: '二维码',
  code_snPlaceholder: '请输入二维码',
  member_nickname: '用户昵称',
  member_nicknamePlaceholder: '请输入用户昵称',
  member_id: '用户ID',
  member_idPlaceholder: '请输入用户ID',
  activity_keyword: '活动信息',
  activity_keywordPlaceholder: '请输入活动名称或ID',
  status: '领取状态',
  statusPlaceholder: '请选择',
  statusPendingShip: '待发货',
  statusCompleted: '已完成',
  statusFailed: '发放失败',
  statusShipped: '已发货待签收',
  statusUnclaimed: '未领取',
  search: '搜索',
  // 表格列
  colSn: '中奖单号',
  colCodeSn: '二维码',
  colUserInfo: '用户信息',
  colActivityInfo: '活动信息',
  activity_name: '活动名称',
  activity_namePlaceholder: '请输入活动名称',
  activity_id: '活动ID',
  activity_idPlaceholder: '请输入活动ID',
  colGiftName: '礼品名称',
  colGiftNum: '数量',
  colMarketPrice: '市场价格',
  colPhone: '联系电话',
  colAddress: '收货地址',
  colStatus: '领取状态',
  colCreatedAt: '创建时间',
  colAction: '操作',
  // 操作
  ship: '发货',
  shipInfo: '发货信息',
  // 占位
  dash: '——',
  none: '无',
  copySuccess: '已复制',
  copyFailed: '复制失败',
  // 发货弹窗
  shipTitle: '发货',
  expressCompany: '快递公司',
  expressCompanyPlaceholder: '请输入快递公司名称',
  expressCompanyRequired: '请输入快递公司名称',
  expressNo: '快递单号',
  expressNoPlaceholder: '请输入快递单号',
  expressNoRequired: '请输入快递单号',
  expressRemark: '备注',
  expressRemarkPlaceholder: '请输入备注',
  expressTime: '发货时间',
  ok: '确定',
  cancel: '取消',
  // 发货信息查看弹窗
  shipInfoTitle: '发货信息',
  // 空状态
  emptyText: '暂无礼品领取记录',
};
